var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"year-icon"},[_c('span',[_vm._v(_vm._s(_vm.yearLabel.substring(0, 2)))]),_c('span',[_vm._v(_vm._s(_vm.yearLabel.substring(2)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }